/**
 * Excel 导入结果展示工具
 * 统一展示后端返回的 HTML 明细（成功/重复/失败），避免只提示「成功」却无数据变化
 */
import { h } from 'vue'
import { notification } from 'ant-design-vue'

const HtmlBlock = {
  props: {
    html: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.$el.innerHTML = this.html
  },
  render() {
    return h('div', {
      style: {
        whiteSpace: 'pre-line',
        maxHeight: '420px',
        overflowY: 'auto',
      },
    })
  },
}

/**
 * @param {Object} vmOrResponse 组件实例（兼容旧调用）或接口响应
 * @param {Object} [maybeResponse] 接口响应
 */
export function showImportResult(vmOrResponse, maybeResponse) {
  const response = maybeResponse !== undefined ? maybeResponse : vmOrResponse
  const reportHtml = (response && (response.data || response.message)) || '导入完成'
  const text = typeof reportHtml === 'string' ? reportHtml : String(reportHtml)
  const hasFail = text.indexOf('失败 ') !== -1 && !/失败\s*0\s*条/.test(text)
  const noSuccess =
    /成功\s*0\s*条/.test(text) ||
    text.indexOf('没有新增') !== -1 ||
    text.indexOf('未解析到有效数据') !== -1
  const notifyType = noSuccess || hasFail ? 'warning' : 'success'
  notification[notifyType]({
    message: '导入结果',
    description: () => h(HtmlBlock, { html: text }),
    duration: 0,
  })
}

/**
 * 判断接口是否业务成功
 */
export function isImportSuccessCode(code) {
  return code === 1 || code === '1' || code == 20001
}
